import React, { memo } from 'react';

type NameCellProps = {
  name: string;
};

export default memo(function NameCell({ name }: NameCellProps) {
  return <div className="name-cell">{name}</div>;
});
